// src/App.tsx
import React from "react";
import { Layout, Typography, ConfigProvider } from "antd";
import { SmileFilled } from "@ant-design/icons"; // Đổi icon trái tim sang mặt cười cho thân thiện
import EQTest from "./components/EQTest";
import "./App.css"; // Nhớ import CSS

const { Content, Footer } = Layout;
const { Title, Text } = Typography;

const App: React.FC = () => {
  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "'Work Sans', sans-serif",
          colorPrimary: "#ff8e53", // Màu cam san hô ấm áp
          borderRadius: 16, // Bo góc lớn tạo cảm giác mềm mại
          colorText: "#4a4a4a", // Màu chữ xám đen thay vì đen tuyền (đỡ gắt)
          colorBgLayout: "transparent", // Để lộ background CSS
        },
        components: {
          Button: {
            controlHeightLG: 50, // Nút bấm to hơn
            fontSizeLG: 16,
            fontWeight: 600,
            defaultShadow: "0 4px 10px rgba(0,0,0,0.05)", // Shadow nhẹ
          },
          Card: {
            boxShadowTertiary: "0 20px 40px rgba(255, 142, 83, 0.1)", // Shadow màu ấm
          },
          Progress: {
            defaultColor: "#ff8e53",
          },
        },
      }}
    >
      <Layout className="app-background" style={{ minHeight: "100vh" }}>
        {/* Header đơn giản, trong suốt */}
        <header
          style={{
            padding: "20px 0",
            textAlign: "center",
          }}
        >
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "10px",
              background: "rgba(255,255,255,0.6)",
              padding: "10px 24px",
              borderRadius: "50px",
              backdropFilter: "blur(5px)",
            }}
          >
            <SmileFilled style={{ fontSize: "28px", color: "#ff8e53" }} />
            <Title
              level={3}
              style={{
                margin: 0,
                color: "#4a4a4a",
                fontSize: "1.5rem",
                fontWeight: 700,
              }}
            >
              Kiểm tra EQ
            </Title>
          </div>
        </header>

        <Content
          style={{
            padding: "0 20px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div style={{ width: "100%", maxWidth: "750px" }}>
            <EQTest />
          </div>
        </Content>

        <Footer
          style={{
            textAlign: "center",
            background: "transparent",
            color: "#8c8c8c",
          }}
        >
          <Text type="secondary" style={{ fontSize: "13px" }}>
            Hành trình thấu hiểu bản thân ©{new Date().getFullYear()} <br />
            Thiết kế với 🧡
          </Text>
        </Footer>
      </Layout>
    </ConfigProvider>
  );
};

export default App;
